import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-mobile-scorm-player',
  templateUrl: './mobile-scorm-player.component.html',
  styleUrls: ['./mobile-scorm-player.component.scss'],
})
export class MobileScormPlayerComponent  implements OnInit {
  @Input() modalTitle: string = "";
  @Input() customStyle: string = "";
  @Input() ionClass: string = "";
  @Input() isOpen:boolean = false;
  @Input() displayHeader:boolean = false;
  @Input() displayFooter:boolean = true;
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  @Output() fullscreenModal: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {}

  closeBaseModal() {
    this.closeModal.emit();
  }
  didDismissModal() {
    this.isOpen = false;
  }

  onFullscreen(isFullscreen) {
    this.fullscreenModal.emit(isFullscreen);
  }

}
